import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import axios from "axios";
import baseUrl from "../../../../BaseURL"
import AlertPOP from "../../../../routes/AlertPOP";
import { ContextData } from "../../../../context/Context";
import validator from "validator";




export default function SetPaymentRegisterForm() {



  const [open, setOpen] = React.useState(false);
  const {RefreshUesFF,setRefreshUesFF,accesstoken,RefreshAmount,setRefreshAmount} = React.useContext(ContextData)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //Form start---------->

  const [formData, setFormData] = useState({
    amount: "",
    registration_type: "" 
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const [message,setmessage] = useState("")
  const [openAlert, setOpenAlert] = useState(false);
  const [transition, setTransition] = useState(undefined);
 

  // Handle the alert transition and function
  const handleClick = (Transition) => {
   setTransition(() => "TransitionLeft")
    setOpenAlert(true);
  };
   // Handle the close alert box
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };





  // Handle submit
  const handleSubmit = (e) => {

    e.preventDefault();

      // Call Alert Box function
      handleClick("left")

    // Check for empty fields
    const isEmptyField = Object.values(formData).every((value) => value === "");

    if (isEmptyField) {
        
      setmessage("Please fill out all fields")
      return 

    } 

    if(!validator.isNumeric(formData.amount)){
      setmessage("fee is not a number")
      return 
    }
      // Submit the form (you can implement your submission logic here)

         // console.log(formData)

      axios.post(`${baseUrl}/auth/set_payment`,formData,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }}).then(res=>{

          
            if(res.data.status){

              setmessage(res.data.statusText)
             
          

              setFormData({
                amount: "",
                registration_type: ""
              })
            }

        
        }).catch(err=> {

            if(err) return  console.log(err)
           
        })


  }




  //Form end --------->

  return (
    <React.Fragment>
    
      <Button variant="contained" onClick={handleClickOpen}>
        Set Payment
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="py-10"
      >
        <AlertPOP
         Open={openAlert}
         handleClose={handleCloseAlert}
         transition={transition}
         message={message}
      />
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>

         
            <form onSubmit={handleSubmit}>
              <TextField
                label="Registration Title"
                helperText="Use a title containing Update, such as Member Update, for paid member changes."
                variant="outlined"
                fullWidth
                margin="normal"
                value={formData.registration_type}
                onChange={handleInputChange("registration_type")}
              />
              
              <TextField
                label="Registration Fee"
                variant="outlined"
                fullWidth
                margin="normal"
                value={formData.amount}
                onChange={handleInputChange("amount")}
              />
      


              <Button type="submit" variant="contained" color="primary">
                Add
              </Button>
            </form>
        
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
